import { render, staticRenderFns } from "./inHouseDoctor.vue?vue&type=template&id=6ec7e1e4&scoped=true&"
import script from "./inHouseDoctor.vue?vue&type=script&lang=js&"
export * from "./inHouseDoctor.vue?vue&type=script&lang=js&"
import style0 from "./inHouseDoctor.vue?vue&type=style&index=0&id=6ec7e1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7e1e4",
  null
  
)

export default component.exports